import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

export default function AuthModal({ onClose }) {
  const { login, register } = useAuth();
  const [mode, setMode]     = useState('login'); // login | register
  const [form, setForm]     = useState({ name: '', email: '', phone: '', password: '' });
  const [error, setError]   = useState('');
  const [loading, setLoading] = useState(false);

  const inputStyle = {
    width: '100%', padding: '14px 16px',
    border: '1px solid #e8ddd0', borderRadius: 12,
    fontSize: 14, background: '#faf8f5', color: '#0d0d0b',
    outline: 'none', transition: 'all 0.2s ease',
    fontFamily: 'inherit'
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      if (mode === 'login') {
        await login(form.email, form.password);
      } else {
        await register(form.name, form.email, form.phone, form.password);
      }
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Помилка. Спробуйте ще раз.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 300, padding: 20, animation: 'fadeIn 0.3s ease'
      }} onClick={e => e.target === e.currentTarget && onClose()}>
        <div style={{
          background: '#fff', borderRadius: 24, padding: '40px 32px',
          width: '100%', maxWidth: 400, boxShadow: '0 24px 60px rgba(0,0,0,0.2)',
          position: 'relative', animation: 'slideUp 0.3s ease'
        }}>
          {/* Кнопка закриття */}
          <button 
            onClick={onClose}
            style={{ 
              position: 'absolute', right: 20, top: 20, border: 'none', 
              background: '#f7f4ef', width: 32, height: 32, borderRadius: '50%', 
              cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', 
              color: '#6b6560', transition: 'background 0.2s' 
            }}
            onMouseEnter={e => e.currentTarget.style.background = '#e8ddd0'}
            onMouseLeave={e => e.currentTarget.style.background = '#f7f4ef'}
          >✕</button>

          {/* Преміальний Логотип */}
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <div style={{
              width: 56, height: 56, margin: '0 auto 16px',
              background: 'linear-gradient(135deg, #e0c992 0%, #c8b89a 100%)',
              borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontFamily: "'Fraunces', serif", fontSize: 26, fontWeight: 600, color: '#141412',
              boxShadow: '0 8px 20px rgba(200, 184, 154, 0.3)'
            }}>О</div>
            <div style={{ fontFamily: "'Fraunces', serif", fontSize: 26, color: '#0d0d0b', fontWeight: 500 }}>
              {mode === 'login' ? 'Вхід в акаунт' : 'Реєстрація'}
            </div>
            <div style={{ fontSize: 11, color: '#8c857d', marginTop: 8, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px' }}>
              Ресторан «Околиця»
            </div>
          </div>

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {mode === 'register' && (
              <>
                <input
                  value={form.name}
                  onChange={e => setForm(f => ({...f, name: e.target.value}))}
                  placeholder="Ваше ім'я"
                  style={inputStyle}
                  onFocus={e => { e.target.style.borderColor = '#d4af37'; e.target.style.background = '#fff'; }}
                  onBlur={e => { e.target.style.borderColor = '#e8ddd0'; e.target.style.background = '#faf8f5'; }}
                />
                <input
                  value={form.phone}
                  onChange={e => setForm(f => ({...f, phone: e.target.value}))}
                  placeholder="Телефон (необов'язково)"
                  style={inputStyle}
                  onFocus={e => { e.target.style.borderColor = '#d4af37'; e.target.style.background = '#fff'; }}
                  onBlur={e => { e.target.style.borderColor = '#e8ddd0'; e.target.style.background = '#faf8f5'; }}
                />
              </>
            )}

            <input
              type="email"
              value={form.email}
              onChange={e => setForm(f => ({...f, email: e.target.value}))}
              placeholder="Email"
              style={inputStyle}
              onFocus={e => { e.target.style.borderColor = '#d4af37'; e.target.style.background = '#fff'; }}
              onBlur={e => { e.target.style.borderColor = '#e8ddd0'; e.target.style.background = '#faf8f5'; }}
            />

            <input
              type="password"
              value={form.password}
              onChange={e => setForm(f => ({...f, password: e.target.value}))}
              placeholder="Пароль"
              style={inputStyle}
              onFocus={e => { e.target.style.borderColor = '#d4af37'; e.target.style.background = '#fff'; }}
              onBlur={e => { e.target.style.borderColor = '#e8ddd0'; e.target.style.background = '#faf8f5'; }}
            />

            {error && (
              <div style={{
                background: '#fff5f5', color: '#c0392b', border: '1px solid #ffe5e5',
                padding: '10px 14px', borderRadius: 10, fontSize: 13, display: 'flex', alignItems: 'center', gap: 8
              }}>
                <span>⚠️</span> {error}
              </div>
            )}

            <button type="submit" disabled={loading} style={{
              background: loading ? '#8c857d' : 'linear-gradient(135deg, #141412 0%, #2a2a2a 100%)',
              color: '#fff', border: 'none', borderRadius: 12,
              padding: '16px', fontSize: 15, fontWeight: 500,
              marginTop: 8, transition: 'transform 0.1s, box-shadow 0.2s', cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }}
            onMouseDown={e => e.currentTarget.style.transform = 'scale(0.98)'}
            onMouseUp={e => e.currentTarget.style.transform = 'scale(1)'}
            >
              {loading ? 'Завантаження...' : mode === 'login' ? 'Увійти' : 'Зареєструватись'}
            </button>
          </form>

          {/* Перемикач Вхід/Реєстрація */}
          <div style={{ textAlign: 'center', marginTop: 20, fontSize: 14, color: '#8c857d' }}>
            {mode === 'login' ? (
              <>Немає акаунту?{' '}
                <button onClick={() => { setMode('register'); setError(''); }} style={{
                  background: 'none', border: 'none', color: '#0d0d0b',
                  fontWeight: 600, cursor: 'pointer', fontSize: 14, padding: 0
                }}>Зареєструватись</button>
              </>
            ) : (
              <>Вже є акаунт?{' '}
                <button onClick={() => { setMode('login'); setError(''); }} style={{
                  background: 'none', border: 'none', color: '#0d0d0b',
                  fontWeight: 600, cursor: 'pointer', fontSize: 14, padding: 0
                }}>Увійти</button>
              </>
            )}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  );
}
